// extracted by mini-css-extract-plugin
export default {"allowOverflow":"vsqB9oD23v3q_bYRT4Rr"};